import React, { PureComponent } from 'react';
import memoizeOne from 'memoize-one';
import PropTypes from 'prop-types';
import { categoryToIcon, getUniquePrizes } from 'containers/Auctions/common';
import { getCategoryLogo } from '../utils/common';
import './DrawingLogo.css';

const RANDOM_DELAY_MS = 3000;
const RANDOM_FACTOR = 0.2;

class DrawingLogo extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      itemIndex: 0,
      itemDurationMs: 0
    };

    this.timeout = null;
    this.switchImages = this.switchImages.bind(this);
    this.getUniquePrizes = memoizeOne(getUniquePrizes.bind(this));
  }

  componentDidMount() {
    this.scheduleNext(Math.floor(RANDOM_DELAY_MS * Math.random()));
  }

  scheduleNext(additionalDelayMs = 0) {
    const { durationMs, transitionMs, prizes } = this.props;
    const uniquePrizes = this.getUniquePrizes(prizes);
    if (this.timeout) {
      clearTimeout(this.timeout);
      this.timeout = null;
    }
    if (uniquePrizes.length) {
      const itemDurationMs = Math.floor(
        durationMs * (1 + Math.random() * RANDOM_FACTOR) + additionalDelayMs
      );
      this.timeout = setTimeout(
        this.switchImages,
        itemDurationMs + transitionMs
      );
      this.setState({ itemDurationMs });
    }
  }

  switchImages() {
    const uniquePrizes = this.getUniquePrizes(this.props.prizes);
    if (uniquePrizes.length) {
      this.setState({
        itemIndex: (this.state.itemIndex + 1) % uniquePrizes.length
      });
      this.scheduleNext();
    }
  }

  componentWillUnmount() {
    if (this.timeout) {
      clearInterval(this.timeout);
    }
  }

  render() {
    const { className, prizes, transitionMs } = this.props;
    const { itemIndex } = this.state;
    const transition = `opacity ${transitionMs}ms linear`;
    const uniquePrizes = this.getUniquePrizes(prizes);
    const category = uniquePrizes[0] && uniquePrizes[0].category;

    return (
      <div className={'drawing-logo ' + (className || '')}>
        <div className="drawing-logo-winning">
          {uniquePrizes.map((item, idx) => {
            const opacity = idx <= itemIndex ? 1 : 0;
            return (
              <img
                key={idx}
                style={{ transition, opacity }}
                src={categoryToIcon(item)}
                alt={item.name}
              />
            );
          })}
        </div>
        <img
          className="drawing-logo-category"
          src={getCategoryLogo(category, true)}
          alt={category || ''}
        />
      </div>
    );
  }
}

DrawingLogo.propTypes = {
  durationMs: PropTypes.number,
  transitionMs: PropTypes.number,
  prizes: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      url: PropTypes.string,
      category: PropTypes.string
    })
  ).isRequired,
  className: PropTypes.string
};

DrawingLogo.defaultProps = {
  durationMs: 4000,
  transitionMs: 300
};

export default DrawingLogo;
